import { Box } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'

import i18n from 'modules/core/lib/i18n'

interface ModalFooterProps {
  onClose: () => void
  onDiscoverMore: () => void
}

const ModalFooter = ({ onClose, onDiscoverMore }: ModalFooterProps) => {
  return (
    <Box flexDirection="row" gap="s8" width="full" justifyContent="flexEnd" paddingTop="s24">
      <Button onClick={onClose} variant="ghost" label={i18n.t('common.close')} />
      <Button
        onClick={onDiscoverMore}
        variant="outline"
        label={i18n.t('upsell.request_modal.confirmation.discover_more')}
      />
    </Box>
  )
}

export default ModalFooter
